import {
  HEADER_AUTH_BUTTON_ACTIVE_STATES_CLASS,
  HEADER_AUTH_BUTTON_THEME_VARS,
} from "@circle-react-shared/uikit/Header/headerThemeVars";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  communitySignInUrl,
  communitySignupUrl,
} from "@circle-react/helpers/communityHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useIsCustomColorTheme } from "@circle-react/hooks/useIsCustomColorTheme";
import { useTanstackRouterQueryParams } from "@circle-react/hooks/useRouterQueryParams";
import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

/**
 * Login + Join buttons for unauthenticated visitors and signed-in non-members.
 * Shared between MobileLoggedOutTopBar (default shell bar) and PageHeader
 * (which replaces the shell bar on space/post pages but still needs auth
 * actions for logged-out users).
 */
export const MobileLoggedOutAuthActions = () => {
  const { currentUser, currentCommunity } = usePunditUserContext();
  // Default theme opts out of community branding entirely,
  // falling back to Compass's own default tokens
  const isCustomColorTheme = useIsCustomColorTheme();
  const {
    post_login_redirect: postLoginRedirectUrlParam,
  }: { post_login_redirect?: string } = useTanstackRouterQueryParams();

  const redirectUrl = postLoginRedirectUrlParam || window.location.href;
  const isSignedIn = Boolean(currentUser);

  const signupUrl = currentCommunity?.private_sign_up_url
    ? currentCommunity.private_sign_up_url
    : communitySignupUrl(currentCommunity, redirectUrl);

  return (
    <div
      className={classNames(
        "flex items-center gap-2",
        isCustomColorTheme && HEADER_AUTH_BUTTON_ACTIVE_STATES_CLASS,
      )}
      style={isCustomColorTheme ? HEADER_AUTH_BUTTON_THEME_VARS : undefined}
    >
      {!isSignedIn && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            const signInUrl = communitySignInUrl(currentCommunity, {
              post_login_redirect: redirectUrl,
            });
            if (signInUrl) {
              window.location.href = signInUrl;
            }
          }}
        >
          {t("log_in")}
        </Button>
      )}
      {signupUrl && (
        <Button
          variant="branded"
          size="sm"
          onClick={() => {
            window.location.href = signupUrl;
          }}
        >
          {currentCommunity?.private_sign_up_url
            ? (currentCommunity.private_sign_up_label ?? t("join"))
            : t("join")}
        </Button>
      )}
    </div>
  );
};
